const DemoProjects =[
    {
        "id":1,
        "image":"https://i.ibb.co/k4SQrMw/ebookhut.png",
        "name":"eBook-Hut",
        "description":"Lorem ipsum dolor sit amet consectetur adipisicing elit. Quos, magni veniam. Molestias aliquam a atque delectus doloribus excepturi debitis? Saepe distinctio repellendus non atque, provident autem modi excepturi aspernatur molestias, soluta accusamus deserunt quia ratione blanditiis architecto tempora accusantium a quas! Perferendis distinctio id, mollitia ex quos omnis reiciendis minus.",
        "technology":"html , css, javascript, react bootstrap, react, node , mongodb,", 
        "live":"https://ebook-hut.netlify.app/",
        "client":"https://github.com/Imran-2021/eBook-Hut-client",
        "backend":"https://www.facebook.com/profile.php?id=100071106706650",
    },

    {
        "id":2,
        "image":"https://i.ibb.co/Xj6zcKY/ehomecleaning.png",
        "name":"eHome-cleaning",
        "description":"Lorem ipsum dolor sit amet consectetur adipisicing elit. Quos, magni veniam. Molestias aliquam a atque delectus doloribus excepturi debitis? Saepe distinctio repellendus non atque, provident autem modi excepturi aspernatur molestias, soluta accusamus deserunt quia ratione blanditiis architecto tempora accusantium a quas! Perferendis distinctio id, mollitia ex quos omnis reiciendis minus.",
        "technology":"html , css, javascript, react bootstrap, react, node , mongodb,", 
        "live":"https://ehouse-cleaning.netlify.app/",
        "client":"https://github.com/Imran-2021/eHome-cleaning-client",
        "backend":"https://www.facebook.com/profile.php?id=100071106706650",

    },

    {
        "id":3,
        "image":"https://i.ibb.co/YpQ096r/devblogs.png",
        "name":"dev-Blogs",
        "description":"Lorem ipsum dolor sit amet consectetur adipisicing elit. Quos, magni veniam. Molestias aliquam a atque delectus doloribus excepturi debitis? Saepe distinctio repellendus non atque, provident autem modi excepturi aspernatur molestias, soluta accusamus deserunt quia ratione blanditiis architecto tempora accusantium a quas! Perferendis distinctio id, mollitia ex quos omnis reiciendis minus.",
        "technology":"html , css, javascript, react bootstrap, react, node , mongodb,", 
        "live":"https://dev-blogs-1.netlify.app/",
        "client":"https://github.com/Imran-2021/Dev-Blogs-client",
        "backend":"https://www.facebook.com/profile.php?id=100071106706650",
    },
    {
        "id":4,
        "image":"https://i.ibb.co/rMpNS3W/netflixcln.png",
        "name":"Netflix | clone",
        "description":"Lorem ipsum dolor sit amet consectetur adipisicing elit. Quos, magni veniam. Molestias aliquam a atque delectus doloribus excepturi debitis? Saepe distinctio repellendus non atque, provident autem modi excepturi aspernatur molestias, soluta accusamus deserunt quia ratione blanditiis architecto tempora accusantium a quas! Perferendis distinctio id, mollitia ex quos omnis reiciendis minus.",
        "technology":"html , css, javascript, react bootstrap, react, node , mongodb,", 
        "live":"https://netflix-cclone.netlify.app/",
        "client":"https://github.com/Imran-2021/Nefflix--Clone",
        "backend":"https://www.facebook.com/profile.php?id=100071106706650",
    },

    {
        "id":5,
        "image":"https://i.ibb.co/rsKjvvY/react-movieticket.png",
        "name":"React-API-movie-ticeket",
        "description":"Lorem ipsum dolor sit amet consectetur adipisicing elit. Quos, magni veniam. Molestias aliquam a atque delectus doloribus excepturi debitis? Saepe distinctio repellendus non atque, provident autem modi excepturi aspernatur molestias, soluta accusamus deserunt quia ratione blanditiis architecto tempora accusantium a quas! Perferendis distinctio id, mollitia ex quos omnis reiciendis minus.",
        "technology":"html , css, javascript, react bootstrap, react, node , mongodb,", 
        "live":"https://movie-ticket-react-api.netlify.app/",
        "client":"https://github.com/Imran-2021/React-API-movie-ticket",
        "backend":"https://www.facebook.com/profile.php?id=100071106706650",
    },

    {
        "id":6,
        "image":"https://i.ibb.co/Xj6zcKY/ehomecleaning.png",
        "name":"eHome-cleaning",
        "description":"Lorem ipsum dolor sit amet consectetur adipisicing elit. Quos, magni veniam. Molestias aliquam a atque delectus doloribus excepturi debitis? Saepe distinctio repellendus non atque, provident autem modi excepturi aspernatur molestias, soluta accusamus deserunt quia ratione blanditiis architecto tempora accusantium a quas! Perferendis distinctio id, mollitia ex quos omnis reiciendis minus.",
        "technology":"html , css, javascript, react bootstrap, react, node , mongodb,", 
        "live":"https://ehouse-cleaning.netlify.app/",
        "client":"https://github.com/Imran-2021/eHome-cleaning-client",
        "backend":"https://www.facebook.com/profile.php?id=100071106706650",

    },
]
export default DemoProjects;